import { ApiService } from "./ApiService.js";
import { FirebaseService } from "./FirebaseService.js";

export class AuthService {
	/**
	 * Login con email/password: autentica en Firebase, luego intercambia el idToken
	 * por nuestro token de API.
	 */
	static async login(email, password) {
		const idToken = await FirebaseService.loginWithEmailPassword(email, password);
		return this.loginWithFirebase(idToken);
	}

	/**
	 * Intercambia un idToken de Firebase por nuestro token de API.
	 * Devuelve { success, user } para usuarios existentes
	 * o { success: true, perfilIncompleto: true, email, nombre, firebaseUid } para usuarios nuevos vía social.
	 */
	static async loginWithFirebase(idToken) {
		const response = await ApiService.post("/apiapp/loginConFirebase", { idToken });

		if (response.perfil_incompleto) {
			return {
				success: true,
				perfilIncompleto: true,
				email: response.email,
				nombre: response.nombre,
				firebaseUid: response.firebase_uid
			};
		}

		const user = response.user;
		if (user) {
			localStorage.setItem("currentUser", JSON.stringify(user));
			return { success: true, user };
		}

		return { success: false, message: "Credenciales inválidas" };
	}

	static async register(userData) {
		const resp = await ApiService.post("/apiapp/RegistrarUsuario", userData);
		if (resp.status <= 0) {
			switch (resp.status) {
				case -1:
					return { success: false, message: "Ya existe un usuario registrado con esos datos" };
				default:
					console.error("Error desconocido al registrar usuario:", resp.message);
					return { success: false, message: "Hubo un error al registrar usuario" };
			}
		}
		return { success: true, message: "Usuario registrado exitosamente" };
	}

	/**
	 * Registra un usuario que se autenticó con Google (perfil incompleto).
	 * Llama a RegistrarUsuarioSocial y guarda el token resultante.
	 */
	static async registerSocial(idToken, firebaseUid, persona, vehiculo) {
		const resp = await ApiService.post("/apiapp/RegistrarUsuarioSocial", {
			idToken,
			firebaseUid,
			persona,
			vehiculo
		});

		if (resp.status > 0 && resp.user) {
			localStorage.setItem("currentUser", JSON.stringify(resp.user));
			return { success: true, user: resp.user };
		}

		return { success: false, message: resp.message || "Error al registrar usuario" };
	}

	static async activateAccount(secTkn, password) {
		const resp = await ApiService.post("apiapp/ResetForgot", { secTkn, password });
		return { success: resp.status > 0, message: resp.message };
	}

	static async forgotPassword(email) {
		await ApiService.get(`/apiapp/forgot?mail=${email}`);
		return { success: true, message: "Se ha enviado un email para recuperar la contraseña" };
	}

	static async logout() {
		try {
			await FirebaseService.signOut();
		} catch (_) {
			// ignorar errores de Firebase en logout
		}
		localStorage.removeItem("currentUser");
		window.location.hash = "login";
	}

	static getCurrentUser() {
		const user = localStorage.getItem("currentUser");
		return user ? JSON.parse(user) : null;
	}

	static async checkAuth() {
		return !!this.getCurrentUser();
	}
}
